export default {
  ids: state => state.ids,
  adasInspection: state => state.adasInspection,
  adasmatrices: state => state.adasmatrices,
  links: state => state.links
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/getters.js